import React from 'react';
import CurrentPlanDetails from '../phone-numbers/current-plan-details.component';
import { ActionLabels, appNote, buttonLabels, emptyLabels, GridStatusLabelVariant, pageTitles, PlansHeaders, RechargeStatusLabels, ToasterTexts } from '../shared/constants';
import { CustomFilterCategory } from '../shared/filters/filter.model';
import { LoadPhoneNumbersGridData, LoadPlanHistory } from "../../actions/index";
import { PlanHistoryModel, RechargeStatus } from '../../models/transaction-history.model';
import { setBackHandler, setHeaderTitle, } from '../../helpers/header.helper';
import ConfirmDialog from "../shared/confirm-dialog.component";
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import ChargebeeService from '../../services/chargebee.service';
import Config from '../../config';
import GridComponent from '../shared/grid';
import { ColDef, ColumnApi, ValueGetterParams } from 'ag-grid-community';
import { ICellRendererParams } from 'ag-grid-community';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import PageHeaderComponent from '../shared/page-header.component';
import { useState, useEffect } from 'react';
import { TypeRenderer } from '../shared/grid/typeRendrer';
import { dateComparator, HeaderTemplate } from '../shared/grid/grid.services';
import { Popover } from '@mui/material';
import { PlanModel, PlanType } from '../../models/plans.model';
import { PhoneNumberModel } from '../../models/phone-number.model';
import { AddOnViewIcon, CancelSubscriptionIcon, PlansGridIcon, ViewDetailsIcon } from '../../icon';
import _ from 'lodash';
import { UtilityService } from '../../services/UtilityService';
import FilterComponent from '../shared/filters/filter.component';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import * as selector from "../../selectors/selectors";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

interface RouteID {
    phoneID: string;
}

const PlanHistoryComponent = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const Plans: PlanModel[] = useSelector(selector.plans)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers)
    const PlanHistory: PlanHistoryModel[] = useSelector(selector.planHistory)


    const [gridApi, setGridApi] = useState<any>()
    const [showPlanDetails, setShowPlanDetails] = useState<boolean>()
    const [currentPlan, setCurrentPlan] = useState<PlanHistoryModel>()
    const [subscriptionID, setSubscriptionID] = useState<string>("")
    const [showCancelSubscriptionConfirmation, setShowCancelSubscriptionConfirmation] = useState<boolean>()
    const [cancelSubscriptionError, setShowCancelSubscriptionError] = useState<boolean>(false)
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)
    const [anchorEl, setAnchorEl] = useState<Element | null>();
    const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false);
    const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
    const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
    const [addOnCancelData, setAddonCancelData] = useState<PlanHistoryModel>()
    const [planTypeOnCancel, setPlanTypeOnCancel] = useState<PlanType>()

    let PlanHistoryColoumnDefs: ColDef[] = [
        {
            field: "id",
            headerName: "ID",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `${params.data.SubscriptionID}`
                }
            },
            wrapText: false,
            autoHeight: false,
            cellStyle: !IsMobileDevice ? { textOverflow: 'ellipsis', paddingTop: "15px" } : null,
            minWidth: 100
        },
        {
            autoHeight: true,
            headerComponentParams: {
                template: selectedFilterTypes.includes("Plans/Add-On") ? `<div style="display: flex"> <div>${HeaderTemplate.plansAddOn}</div><div>${HeaderTemplate.filterApplied(true)}</div></div>` : `${HeaderTemplate.plansAddOn}`
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.PlanName
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (!!params.data) {
                    const label = params.data.PlanName
                    const Icon = params.data.PlanType === 2 ? AddOnViewIcon : PlansGridIcon
                    const css = params.data.PlanType === 2 ? "color-addon-text" : "color-plan-text"
                    const Status = {
                        component: TypeRenderer,
                        params: {
                            Icon: Icon, Label: label, Id: params.data.ID, ClassName: css
                        }
                    }
                    return Status
                }
            },
            minWidth: 170
        },
        {
            field: "StatusType",
            headerName: "Status",
            autoHeight: true,
            headerComponentParams: {
                template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
            },
            valueGetter: (params: ValueGetterParams) => {
                return params.data.StatusType === RechargeStatus.ONGOING ? RechargeStatusLabels.ONGOING : params.data.StatusType === RechargeStatus.UPCOMING ? RechargeStatusLabels.UPCOMING : params.data.StatusType === RechargeStatus.COMPLETED ? RechargeStatusLabels.COMPLETED : params.data.StatusType === RechargeStatus.ON_HOLD ? RechargeStatusLabels.ON_HOLD : params.data.StatusType === RechargeStatus.CANCELLED ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (!!params.data) {
                    const label = params.data.StatusType === RechargeStatus.ONGOING ? RechargeStatusLabels.ONGOING : params.data.StatusType === RechargeStatus.UPCOMING ? RechargeStatusLabels.UPCOMING : params.data.StatusType === RechargeStatus.COMPLETED ? RechargeStatusLabels.COMPLETED : params.data.StatusType === RechargeStatus.ON_HOLD ? RechargeStatusLabels.ON_HOLD : params.data.StatusType === RechargeStatus.CANCELLED ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE
                    const variant = params.data.StatusType === RechargeStatus.ONGOING ? GridStatusLabelVariant.Info : params.data.StatusType === RechargeStatus.UPCOMING ? GridStatusLabelVariant.Other : params.data.StatusType === RechargeStatus.COMPLETED ? GridStatusLabelVariant.Active : params.data.StatusType === RechargeStatus.ON_HOLD ? GridStatusLabelVariant.Warning : GridStatusLabelVariant.Danger;
                    const Status = {
                        component: StatusRenderer,
                        params: {
                            Variant: variant, Label: label, Id: params.data.ID,
                        }
                    }
                    return Status
                }
            },
            minWidth: 130,
            width: 130,
            maxWidth: 130
        },
        {
            field: "CreatedDate",
            headerName: "CreatedDate",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.CreatedDateTime}`
            },
            sort: "desc",
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            minWidth: 150,
            width: 150,
            maxWidth: 150
        },
        {
            field: "StartDate",
            headerName: "StartDate",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${params.data.StartDate}`
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.StartDate, nodeB.data.StartDate),
            minWidth: 130,
            width: 130,
            maxWidth: 130
        },
        {
            field: "EndDate",
            headerName: "EndDate",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${!!params.data.EndDate && (params.data.StatusType === RechargeStatus.COMPLETED || (params.data.StatusType === RechargeStatus.ONGOING && !!params.data.CancelDate)) ? params.data.EndDate : "---"}`
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.EndDate, nodeB.data.EndDate),
            minWidth: 130,
            width: 130,
            maxWidth: 130
        },
        {
            field: "RenewalDate",
            headerName: "RenewalDate",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return `${!!params.data.RenewDate && params.data.StatusType === RechargeStatus.ONGOING && !params.data.CancelDate ? params.data.RenewDate : "---"}`
            },
            minWidth: 130,
            width: 130,
            maxWidth: 130
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params =>
                <ActionsRenderer MenuData={[{
                    Name: ActionLabels.PLAN_DETAILS,
                    Icon: ViewDetailsIcon,
                    OnClick: () => showCurrentPlan(params)
                },
                {
                    Name: params.data.PlanType === PlanType.TIER ? ActionLabels.CANCEL_SUBSCRIPTION : ActionLabels.CANCEL_ADDON,
                    Icon: CancelSubscriptionIcon,
                    Hide: !(!params.data.IsItemCancelled && (params.data.StatusType === RechargeStatus.ONGOING || params.data.StatusType === RechargeStatus.UPCOMING)),
                    OnClick: () => ShowCancelSubscription(params.data, params.data.PlanType)
                },
                ]}
                    {...params}
                />,
            resizable: false,
            sortable: false,
        },
    ]

    const params = useParams();

    useEffect(() => {
        const phoneID = params.phoneID
        LoadPlanHistory(dispatch, phoneID)
        if (PhoneNumbers.length < 1) {
            LoadPhoneNumbersGridData(dispatch)
        }
        let Name = PhoneNumbers.find((num: PhoneNumberModel) => num.ID === phoneID)?.Name || ""
        setHeaderTitle(`${pageTitles.PLANS_HISTORY} - (${Name})`);
        setBackHandler(() => navigate(-1));
    }, []);

    const onGridReady = (params) => {
        setGridApi(params.api)
        setColumnApi(params.columnApi)
    }

    const onSearch = (e: any) => {
        gridApi.setQuickFilter(e.target.value)
    }

    const showCurrentPlan = (params) => {
        setShowPlanDetails(true)
        setCurrentPlan(params.data)
    }

    const closePlanDetails = () => {
        setShowPlanDetails(false)
    }
    const ShowCancelSubscription = (phoneData, planType) => {
        setSubscriptionID(phoneData.SubscriptionID)
        setAddonCancelData(phoneData)
        setShowCancelSubscriptionConfirmation(true)
        setPlanTypeOnCancel(planType)
    }

    const cancelSubscription = () => {
        closeCancelSubscriptionConfirmation();
        setToast(ToasterTexts.CANCELLING_SUBSCRIPTION, ToasterType.INFO)
        if (planTypeOnCancel === PlanType.TIER) {
            ChargebeeService.cancelSubscription([subscriptionID]).then(res => {
                if (res.status === 200) {
                    setShowCancelSubscriptionError(false)
                    setToast(ToasterTexts.CANCEL_SUBSCRIPTION_SUCCESS, ToasterType.SUCCESS)
                    LoadPhoneNumbersGridData(dispatch);
                    LoadPlanHistory(dispatch, addOnCancelData.PhoneNumberID)
                }
            }).catch(error => {
                if (error.response.status === 500) {
                    setShowCancelSubscriptionError(true)
                    //todo
                }
                else {
                    setToast(ToasterTexts.CANCEL_SUBSCRIPTION_FAILED, ToasterType.DANGER)
                    setShowCancelSubscriptionError(false)
                }
            })
        }
        else {
            cancelAddOnSubscription()
        }
    }

    const cancelAddOnSubscription = () => {
        // closeCancelSubscriptionConfirmation();
        // setToast(ToasterTexts.CANCELLING_SUBSCRIPTION, ToasterType.INFO)
        // let itemId = `Pricing_${addOnCancelData.ID}`;
        let phoneId = addOnCancelData.PhoneNumberID;
        let quantity = (PhoneNumbers.find(x => x.ID === phoneId)?.Plans?.filter(y => y.PlanID === addOnCancelData.PlanID && y.StatusType === RechargeStatus.ONGOING && !y.IsItemCancelled).length || 0) + 1;

        ChargebeeService.cancelItem(`Pricing_${addOnCancelData?.PlanID}`, [addOnCancelData?.ID || ""], phoneId, addOnCancelData?.SubscriptionID || "", quantity).then(res => {
            if (res.status === 200) {
                setToast(ToasterTexts.CANCEL_SUBSCRIPTION_SUCCESS, ToasterType.SUCCESS)
                LoadPlanHistory(dispatch, phoneId)
            }
        }).catch(error => {
            setToast(ToasterTexts.CANCEL_SUBSCRIPTION_FAILED, ToasterType.DANGER)
        })
    }


    const closeCancelSubscriptionConfirmation = () => {
        setShowCancelSubscriptionConfirmation(false)
        setSubscriptionID("")
    }

    const initialFilterOptions = () => {
        const filterData: CustomFilterCategory[] = [

            {
                Id: 1,
                Title: 'Plans/Add-On',
                IsSelectedAll: false,
                Options: _(PlanHistory)
                    .map((row) => ({
                        Key: "PlanName",
                        Id: row.ID,
                        Label: row.PlanName,
                        Value: row.PlanName,
                        IsSelected: false
                    }))
                    .uniqBy('Label')
                    .value()
            },
            {
                Id: 2,
                Title: 'Status',
                IsSelectedAll: false,
                Options: _(PlanHistory)
                    .map((row) => ({
                        Key: "StatusType",
                        Id: row.ID,
                        Label: row.StatusType === RechargeStatus.ONGOING ? RechargeStatusLabels.ONGOING : row.StatusType === RechargeStatus.UPCOMING ? RechargeStatusLabels.UPCOMING : row.StatusType === RechargeStatus.COMPLETED ? RechargeStatusLabels.COMPLETED : row.StatusType === RechargeStatus.ON_HOLD ? RechargeStatusLabels.ON_HOLD : row.StatusType === RechargeStatus.CANCELLED ? RechargeStatusLabels.CANCELLED : RechargeStatusLabels.NONE,
                        Value: row.StatusType,
                        IsSelected: false
                    }))
                    .uniqBy('Label')
                    .value()
            }
        ]
        setFilterOptions(filterData)
    }

    useEffect(() => {
        initialFilterOptions()
    }, [PlanHistory])

    const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {

        if (IsMobileDevice) {
            setShowFilterOptions(true);
        }
        else {
            setAnchorEl(event.currentTarget)
        }
    }

    const handleCloseFilter = () => {
        setAnchorEl(null);
        setShowFilterOptions(false);
    }

    const handleApplyFilters = (filters) => {
        setFilterOptions(filters);
        const { result } = UtilityService.getFilterTypes(filters);
        setSelectedFilterTypes(result)
    };

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            <PageHeaderComponent
                Actions={[]}
                HandleFilter={handleClickFilter}
                ShowFilterIcon={true}
                IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
                onSearch={onSearch}
                PlaceHolder={"Find a Plan ..."}
                Count={0} />
            <div className='h-v-85'>
                <GridComponent
                    ColumnDefs={PlanHistoryColoumnDefs}
                    RowData={PlanHistory}
                    OnGridReady={onGridReady} IsPaginationEnabled={true}
                    EmptyLabel={emptyLabels.TRANSACTION_HISTORY}
                    LockVisible={true}
                    filterOptions={filterOptions}
                    IsFilterPresent={true}
                    gridApi={gridApi}
                    isHorizontalScroll={true}
                />
            </div>
            {
                showPlanDetails &&
                <CurrentPlanDetails
                    Open={showPlanDetails} HandleClose={closePlanDetails} CurrentPlan={currentPlan} IsMobileDevice={IsMobileDevice}
                />
            }
            {
                showCancelSubscriptionConfirmation &&
                <ConfirmDialog
                    onClose={(flag) => {
                        if (flag) {
                            cancelSubscription();
                        }
                        else {
                            closeCancelSubscriptionConfirmation();
                        }
                    }}
                    Title={PlansHeaders.CONFIRM}
                    Show={showCancelSubscriptionConfirmation}
                    Text={appNote.CANCEL_SUBSCRIPTION_CONFIRMATION}
                    ButtonName={buttonLabels.OKAY}
                    IsMobileDevice={IsMobileDevice} />
            }
            {
                cancelSubscriptionError && <ConfirmDialog
                    onClose={() => setShowCancelSubscriptionError(false)}
                    Show={cancelSubscriptionError}
                    TextProps={() => <p>{ToasterTexts.UNABLE_CANCEL_SUBSCRIPTION} (<a href={`mailto: ${Config.SUPPORT_EMAIL}`} className={`color-primary-light`}>{Config.SUPPORT_EMAIL}</a>) to cancel this Add-on subscription.</p>}
                    ButtonName={buttonLabels.OKAY}
                    HideCancel={true}
                    IsMobileDevice={IsMobileDevice}
                />
            }
            {
                !IsMobileDevice && Boolean(anchorEl) &&

                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleCloseFilter}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    classes={{ paper: ` ${ShowFilterOptions ? "min-h-40" : ""}` }}
                    BackdropProps={{
                        invisible: true,
                        onClick: (event) => event.stopPropagation(),
                    }}
                >
                    <FilterComponent
                        Filters={filterOptions}
                        HandleApplyFilters={handleApplyFilters}
                        OnClose={handleCloseFilter}
                    />
                </Popover>
            }
        </div>
    )
}

export default PlanHistoryComponent;

